import React, { useState, useEffect } from 'react';
import './App.css';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import emailjs from '@emailjs/browser';

const firebaseConfig = {
  apiKey: "AIzaSyCssPmZEr123f4QumVj8Uw-mZKPm4_L9pc",
  authDomain: "visualizer-f2095.firebaseapp.com",
  projectId: "visualizer-f2095",
  storageBucket: "visualizer-f2095.firebasestorage.app",
  messagingSenderId: "632056453495",
  appId: "1:632056453495:web:c22f700e14a66f5e06a972"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  // Check URL parameter to show demo form by default
  const urlParams = new URLSearchParams(window.location.search);
  const [showDemoForm, setShowDemoForm] = useState(urlParams.get('demo') === 'true');
  
  const [demoName, setDemoName] = useState('');
  const [demoOrg, setDemoOrg] = useState('');
  const [demoEmail, setDemoEmail] = useState('');

  // Initialize Lucide icons
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/lucide@latest';
    script.async = true;
    script.onload = () => {
      if (window.lucide) window.lucide.createIcons();
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Reinitialize icons when showPassword changes
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.lucide) window.lucide.createIcons();
    }, 100);
    return () => clearTimeout(timer);
  }, [showPassword]);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      
      // Log login event with IP
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        await addDoc(collection(db, 'loginHistory'), {
          userId: userCredential.user.uid,
          email: userCredential.user.email,
          ipAddress: ipData.ip,
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent
        });
      } catch (ipError) {
        console.log('IP logging failed:', ipError);
        // Continue login even if IP logging fails
      }
      
      onLogin();
    } catch (err) {
      setError('Login failed. Check credentials.');
    }
  };

  const handleDemoAccess = async () => {
    if (!demoName || !demoOrg || !demoEmail) {
      setError('Please fill in all demo fields.');
      return;
    }
    
    try {
      // Save demo request to Firestore
      await addDoc(collection(db, 'demoRequests'), {
        name: demoName,
        organization: demoOrg,
        email: demoEmail,
        requestDate: new Date().toISOString(),
        status: 'pending'
      });

      // Send email notification via EmailJS
      await emailjs.send(
        'service_kehvr29',
        'template_i6yphja',
        { name: demoName, organization: demoOrg, email: demoEmail, requestDate: new Date().toLocaleString() },
        'qgmJBKDuxq1iLS1Zs'
      );
      
      // Show success message
      setError('');
      alert('Thank you! We\'ll review your request and email you login credentials within 24 hours.');
      
      // Reset form and return to login
      setShowDemoForm(false);
      setDemoName('');
      setDemoOrg('');
      setDemoEmail('');
    } catch (err) {
      setError('Request submission failed. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="flex justify-center mb-6">
          <svg viewBox="0 0 360 120" xmlns="http://www.w3.org/2000/svg" style={{ width: '300px', height: 'auto' }}>
            <defs>
              <linearGradient id="loginPrismGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#8B5CF6', stopOpacity: 1 }} />
              </linearGradient>
              <linearGradient id="loginPrismGrad2" x1="0%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#10B981', stopOpacity: 0.9 }} />
                <stop offset="100%" style={{ stopColor: '#3B82F6', stopOpacity: 0.9 }} />
              </linearGradient>
              <linearGradient id="loginTextGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#1E40AF', stopOpacity: 1 }} />
                <stop offset="50%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#60A5FA', stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            <g transform="translate(35, 20)">
              <path d="M 30 0 L 40 30 L 30 50 L 20 30 Z" fill="url(#loginPrismGrad1)" opacity="0.9"/>
              <path d="M 0 30 L 20 30 L 15 50 L 5 40 Z" fill="#3B82F6" opacity="0.7"/>
              <path d="M 40 30 L 60 30 L 55 40 L 45 50 Z" fill="url(#loginPrismGrad2)" opacity="0.8"/>
              <path d="M 15 50 L 30 65 L 45 50 Z" fill="#8B5CF6" opacity="0.8"/>
            </g>
            <text x="110" y="55" fontFamily="Arial, sans-serif" fontSize="32" fill="url(#loginTextGradient)">
              <tspan fontWeight="700">Patents</tspan><tspan fontWeight="300">Prism</tspan>
            </text>
            <text x="110" y="75" fontFamily="Arial, sans-serif" fontSize="11" fontWeight="400" fill="#94A3B8" letterSpacing="1.5">
              PATENT ANALYSIS &amp; INSIGHTS
            </text>
          </svg>
        </div>
        
        {!showDemoForm ? (
          <div>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
            />
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                style={{ paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: 'calc(50% - 0.5rem)',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#9CA3AF',
                  opacity: 0.6,
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.2s',
                  height: '20px',
                  width: '20px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '0.6'}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  <i data-lucide="eye-off" style={{ width: '18px', height: '18px' }}></i>
                ) : (
                  <i data-lucide="eye" style={{ width: '18px', height: '18px' }}></i>
                )}
              </button>
            </div>
            {error && <p className="login-error">{error}</p>}
            <button onClick={handleLogin} className="login-button">
              Login
            </button>
            <button onClick={() => setShowDemoForm(true)} className="login-demo-button">
              Try Demo
            </button>
          </div>
        ) : (
          <div>
            <input
              type="text"
              placeholder="Name"
              value={demoName}
              onChange={(e) => setDemoName(e.target.value)}
              className="login-input"
            />
            <input
              type="text"
              placeholder="Organization"
              value={demoOrg}
              onChange={(e) => setDemoOrg(e.target.value)}
              className="login-input"
            />
            <input
              type="email"
              placeholder="Email"
              value={demoEmail}
              onChange={(e) => setDemoEmail(e.target.value)}
              className="login-input"
            />
            {error && <p className="login-error">{error}</p>}
            <button onClick={handleDemoAccess} className="login-button">
              Request Access
            </button>
            <button onClick={() => { setShowDemoForm(false); setError(''); }} className="login-demo-button">
              Back to Login
            </button>
          </div>
        )}
      </div>
      <div className="login-footer">
        © 2025{new Date().getFullYear() > 2025 ? `-${new Date().getFullYear()}` : ''} PatentsPrism. All rights reserved.
      </div>
    </div>
  );
}
